<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <h3 class="page-title">Gửi Thông Báo Test</h3>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-body">
              <form @submit.prevent="sendNotification">
                
                <div class="form-group">
                  <label>Danh sách ID Người Nhận</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    v-model="form.idNguoiNhansStr" 
                    placeholder="Ví dụ: 2, 3, 4"
                    required>
                  <small class="form-text text-muted">Nhập các ID người nhận, cách nhau bởi dấu phẩy.</small>
                </div>

                <div class="form-group">
                  <label>Loại Thông Báo</label>
                  <select class="form-control" v-model="form.loaiThongBao" required>
                    <option value="NEW_COMMENT">Bình luận mới</option>
                    <option value="TASK_ASSIGNED">Giao việc mới</option>
                    <option value="TEST_NOTIFICATION">Thông báo Test</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>Loại Đối Tượng</label>
                  <input type="text" class="form-control" v-model="form.loaiDoiTuong">
                </div>
                
                <div class="form-group">
                  <label>ID Đối Tượng</label>
                  <input type="number" class="form-control" v-model.number="form.idDoiTuong">
                </div>

                <div class="mt-4">
                  <button type="submit" class="btn btn-primary" :disabled="isLoading">
                    <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Đang gửi...' : 'Gửi Thông Báo' }}
                  </button>
                </div>
              </form>

              <div v-if="message" class="alert mt-3" :class="isError ? 'alert-danger' : 'alert-success'">
                {{ message }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import service để gọi API
import { notificationService } from '@/services/NotificationService';

export default {
  name: "TaoThongBaoTest",
  data() {
    return {
      // Dữ liệu của form, được liên kết với các ô input qua v-model
      form: {
        idNguoiNhansStr: '2, 3', // Giá trị mặc định để test cho nhanh
        loaiThongBao: 'NEW_COMMENT',
        loaiDoiTuong: 'bang-phan-chia-cong-viec',
        idDoiTuong: 101,
      },
      // Các biến trạng thái của giao diện
      isLoading: false,
      message: '',
      isError: false,
    };
  },
  methods: {
    /**
     * Hàm này được gọi khi người dùng nhấn nút "Gửi Thông Báo".
     */
    async sendNotification() {
      this.isLoading = true;
      this.message = '';
      this.isError = false;

      try {
        // 1. Lấy chuỗi ID từ form, ví dụ: "2, 3, 4"
        const idsString = this.form.idNguoiNhansStr;
        if (!idsString) {
          throw new Error("Danh sách người nhận không được để trống.");
        }

        // 2. Chuyển chuỗi thành một mảng các số ID hợp lệ
        const idNguoiNhans = idsString
          .split(',')                 // Tách chuỗi bằng dấu phẩy
          .map(id => id.trim())       // Xóa khoảng trắng thừa
          .filter(id => id)           // Loại bỏ các phần tử rỗng
          .map(id => parseInt(id, 10))// Chuyển các phần tử thành số
          .filter(id => !isNaN(id));  // Chỉ giữ lại các số hợp lệ

        if (idNguoiNhans.length === 0) {
          throw new Error("Vui lòng nhập ít nhất một ID người nhận hợp lệ.");
        }
        
        // 3. Chuẩn bị dữ liệu để gửi đi, khớp với DTO mới ở backend
        const notificationData = {
          idNguoiNhans: idNguoiNhans, // Gửi đi một mảng số
          loaiThongBao: this.form.loaiThongBao,
          loaiDoiTuong: this.form.loaiDoiTuong,
          idDoiTuong: this.form.idDoiTuong,
        };
        
        // 4. Gọi hàm createNotification từ service
        await notificationService.createNotification(notificationData);
        
        this.message = `Gửi thông báo thành công đến các người dùng ID: ${idNguoiNhans.join(', ')}!`;

      } catch (error) {
        this.isError = true;
        this.message = "Có lỗi xảy ra: " + (error.response?.data?.message || error.message);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
/* Style cơ bản cho card */
.card {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}
</style>